import React from 'react';
import BookAppointmentLink from './BookAppointmentLink';

const NotificationBar: React.FC = () => {
  return (
    <div className="hidden lg:block bg-lime-300 text-gray-800 py-2 sm:py-3 px-4 text-center relative overflow-hidden lg:rounded-t-3xl">
      <div className="container-custom">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-8">
          <span className="font-normal text-xs sm:text-sm font-founders">
            Schedule an Appointment
          </span>
          <BookAppointmentLink 
            analyticsSource="notification_bar"
            className="text-gray-800 hover:text-gray-900 text-xs sm:text-sm font-medium font-founders inline-flex items-center justify-center min-h-[32px]"
          >
            BOOK NOW →
          </BookAppointmentLink>
        </div>
      </div>
    </div>
  );
};

export default NotificationBar;